export type NavigationRoute =
  | 'main'
  | 'records'
  | 'analytics'
  | 'reports'
  | 'presets'
  | 'templates'
  | 'settings'
  | 'users'
  | 'users_groups'
  | 'qm_users'
  | 'dictionaries'
  | 'createDictionaries'
  | 'authorization'
  | 'projects'
  | 'metric'
  | 'triggers'
  | 'newProject'
  | 'reportCharts'
  | 'reportRecords'
  | 'projectRecords'
  | 'auditLogs'
  | 'wordsCloud'
  | 'error'
  | 'settingsAlias'
  | 'settingsRecognitionRules'
  | 'integration'
  | 'wordsNGramm'
  | 'login'
  | 'manualRecordingUpload'
  | 'staticReport'
  | 'messagesHistory'
  | 'newChatProject'
  | 'messagesManaging'
  | 'settingsCommon'
  | 'subscribe'
  | 'subscribeError'
  | 'unsubscribeFromTrigger'
  | 'unsubscribeFromAll'
  | 'unsubscribeFromReport'
  | 'unsubscribeFromTriggerError'
  | 'unsubscribeFromAllError'
  | 'unsubscribeFromReportError'
  | 'chatReports'
  | 'chatWordsNGramm'
  | 'chatProjectRecords'
  | 'qm_module_statistic'
  | 'qm_module_appeal'
  | 'qm_module_manage'
  | 'qm_manage_monitoring_forms'
  | 'qm_manage_monitoring_tasks'
  | 'qm_manage_commands'
  | 'qm_manage_assessment_templates'
  | 'qm_manage_monitoring_forms_criteria_tab'
  | 'qm_manage_monitoring_tasks_controllers'
  | 'qm_manage_monitoring_tasks_monitoring'
  | 'users_synchronization_AD';

export type ChatNavigationRoutes = 'allChats' | 'chatAnalytic' | 'chatMetricTemplates';
export type NavigationType = NavigationRoute | ChatNavigationRoutes;

export const navigationRoutes: Record<NavigationType, string> = {
  main: '/',
  login: 'authorization',
  records: 'records',
  analytics: 'analytics',
  reports: 'reports',
  chatReports: 'chat-reports',
  presets: 'presets',
  templates: 'templates',
  settings: 'settings',
  users: 'users',
  users_groups: 'users_groups',
  qm_users: 'qm',
  settingsCommon: 'common',
  settingsAlias: 'alias',
  settingsRecognitionRules: 'recognitionRules',
  newChatProject: 'new_chat_project',
  dictionaries: 'dictionaries',
  createDictionaries: 'createDictionaries',
  authorization: 'authorization',
  projectRecords: 'project-records',
  chatProjectRecords: 'chat-project-records',
  projects: 'projects',
  metric: 'metricTemplates',
  newProject: 'new_project',
  triggers: 'triggers',
  reportCharts: 'report-charts',
  reportRecords: 'report-records',
  auditLogs: 'audit-logs',
  wordsCloud: 'words-cloud',
  wordsNGramm: 'words-phrase-cloud',
  chatWordsNGramm: 'chat-words-phrase-cloud',
  error: 'error',
  integration: 'integrationSettings',
  manualRecordingUpload: 'manualRecordingUpload',
  staticReport: 'staticReport',
  messagesHistory: 'messagesHistory',
  messagesManaging: 'messagesManaging',
  allChats: 'chats',
  chatAnalytic: 'chatAnalytic',
  chatMetricTemplates: 'chatMetricTemplates',
  subscribe: 'subscribe',
  subscribeError: 'subscribe_error',
  unsubscribeFromTrigger: 'unsubscribe_trigger',
  unsubscribeFromTriggerError: 'unsubscribe_trigger_error',
  unsubscribeFromAll: 'unsubscribe',
  unsubscribeFromAllError: 'unsubscribe_error',
  unsubscribeFromReport: 'unsubscribe_report',
  unsubscribeFromReportError: 'unsubscribe_report_error',
  qm_module_statistic: 'qm_statistic',
  qm_module_appeal: 'qm_appeal',
  qm_module_manage: 'qm_manage',
  qm_manage_monitoring_tasks: 'monitoring_tasks',
  qm_manage_monitoring_tasks_controllers: 'controllers',
  qm_manage_monitoring_tasks_monitoring: 'monitoring',
  qm_manage_commands: 'commands',
  qm_manage_assessment_templates: 'assessment_templates',
  qm_manage_monitoring_forms: 'monitoring_forms',
  qm_manage_monitoring_forms_criteria_tab: 'criteria',
  users_synchronization_AD: 'synchronization_ad',
};

export type NavigationRoutes = typeof navigationRoutes;
